import React from 'react';
import Section from '../components/ui/Section';
import Header from './Header';
import Footer from './Footer';
import heroHome from '../assets/images/hero-home.jpg';
import consulting from '../assets/images/home-consulting.jpg';
import capital from '../assets/images/home-capital.jpg';
import technology from '../assets/images/home-technology.jpg';
import campus from '../assets/images/about-hero.jpg';
import analytics from '../assets/images/home-tile-analytics.jpg';
import './Media.css';

const mediaItems = [
    {
        src: heroHome,
        alt: 'Daylit glass atrium with a concrete staircase',
        caption: 'Home hero — atrium, daylight, scale.',
    },
    {
        src: consulting,
        alt: 'Frosted glass panels with an abstract process graph',
        caption: 'Consulting — structure and alignment.',
    },
    {
        src: capital,
        alt: 'Stacked translucent glass blocks',
        caption: 'Capital — growth as geometry.',
    },
    {
        src: technology,
        alt: 'Fibre-optic strands catching daylight',
        caption: 'Technology — data and infrastructure.',
    },
    {
        src: campus,
        alt: 'Glass campus facade and pedestrian plaza',
        caption: 'About — institutional, open, on the ground.',
    },
    {
        src: analytics,
        alt: 'Bright meeting room with a wall-mounted dashboard',
        caption: 'Analytics — decision-ready rooms.',
    },
];

const Media = () => {
    return (
        <div className="media-page">
            <Header variant="marketing" />
            <Section variant="large" className="media-section">
                <div className="media-content">
                    <h1 className="media-heading">Media</h1>
                    <div className="media-boxes">
                        {mediaItems.map((item) => (
                            <div className="media-box" key={item.caption}>
                                <img src={item.src} alt={item.alt} className="media-box-image" />
                                <p className="media-box-text">{item.caption}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </Section>
            <Footer />
        </div>
    );
};

export default Media;
